import { Request, BaseApiUrl, getExportExcel } from "./api";
/*
// 销售过磅-导出
export const DownWeighingSaleOutHistry = (params,title) => {
 return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingSaleOutHistry`,params,title);
};
*/

//所有报表接口入口

// 原材料耗料报表
export const GetReportManufacture = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufacture`, { params: params });
};
// 原材料耗料报表-导出
export const DownReportManufacture = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufacture`, params, title);
};

// 原材料入库报表
export const GetReportMatReceive = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportMatReceive`, { params: params });
};
// 原材料入库报表-导出
export const DownReportMatReceive = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportMatReceive`, params, title);
};

// 生产日报表
export const GetReportProjectDay = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportProjectDay`, { params: params });
};
// 生产日报表-导出
export const DownReportProjectDay = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportProjectDay`, params, title);
};

// 工程耗料报表
export const GetReportManufactureProject = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufactureProject`, { params: params });
};
// 工程耗料报表-导出
export const DownReportManufactureProject = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufactureProject`, params, title);
};


// 任务完成率报表
export const GetReportProdTask = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportProdTask`, { params: params });
};
// 任务完成率报表-导出
export const DownReportProdTask = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportProdTask`, params, title);
};

// 获取罐子库存图数据
export const GetStockReport = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetStockReport`, { params: params });
};
//获取销售出货最后一个单据编号+1
export const geLastNumberNo = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GeLastNumberNo`, { params: params });
};


// 进料过磅材料明细报表
export const GetWeighingIn = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingIn`, { params: params });
};
// 进料过磅材料明细报表-导出
export const DownWeighingIn = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingIn`, params, title);
};

// 生产明细表
export const GetProdOutMasterDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdOutMasterDetail`, { params: params });
};
// 生产明细表导出
export const DownProdOutMasterDetail = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdOutMasterDetail`, params, title);
};

// 生产统计表
export const GetProdOutMasterGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdOutMasterGroup`, { params: params });
};
// 生产统计表导出
export const DownProdOutMasterGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdOutMasterGroup`, params, title);
};

// 生产统计表
export const GetProdTaskDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdTaskDetail`, { params: params });
};
// 任务单统计导出
export const DownProdTaskDetail = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdTaskDetail`, params, title);
};

// 进料过磅材料统计报表
export const GetWeighingInGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingInGroup`, { params: params });
};
// 进料过磅材料统计报表-导出
export const DownWeighingInGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingInGroup`, params, title);
};

// 出料过磅报表
export const GetWeighingout = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingout`, { params: params });
};
// 出料过磅报表-导出
export const DownWeighingout = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingout`, params, title);
};

// 销售过磅统计报表
export const GetWeighingInSaleOutGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingInSaleOutGroup`, { params: params });
};
// 销售过磅统计报表-导出
export const DownWeighingInSaleOutGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingInSaleOutGroup`, params, title);
};
// 出料过磅统计报表
export const GetWeighingoutGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingoutGroup`, { params: params });
};
// 出料过磅统计报表-导出
export const DownWeighingoutGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingoutGroup`, params, title);
};
// 消耗合计报表
export const GetManufactureAmount = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetManufactureAmount`, { params: params });
};
// 消耗合计报表-导出
export const DownManufactureAmount = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownManufactureAmount`, params, title);
};

// 工程耗料合计报表
export const GetReportManufactureProjectAmount = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufactureProjectAmount`, { params: params });
};
// 工程耗料合计报表-导出
export const DownReportManufactureProjectAmount = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufactureProjectAmount`, params, title);
};
// 强度等级耗料合计报表
export const GetReportManufactureGradeAmount = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufactureGradeAmount`, { params: params });
};
// 强度等级耗料合计报表-导出
export const DownReportManufactureGradeAmount = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufactureGradeAmount`, params, title);
};
// 车辆出车统计表
export const GetProdVehicleGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdVehicleGroup`, { params: params });
};
// 车辆出车统计表-导出
export const DownProdVehicleGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdVehicleGroup`, params, title);
};


//协会模块--开始
// 协会生产汇总
export const XHGetMaterialSummary = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/XHGetMaterialSummary`, { params: params });
};
// 导出协会生产汇总
export const XHDownMaterialSummary = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/XHDownMaterialSummary`, params, title);
};


// 协会工程方量汇总
export const XHGetProjectQuantitySummary = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/XHGetProjectQuantitySummary`, { params: params });
};
// 导出协协会工程方量汇总
export const XHDownProjectQuantitySummary = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/XHDownProjectQuantitySummary`, params, title);
};

// 获取协会工程明细方量汇总
export const XHGetProjectQuantityDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/XHGetProjectQuantityDetail`, { params: params });
};
// 导出协会工程明细方量汇总
export const XHDownProjectQuantityDetail = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/XHDownProjectQuantityDetail`, params, title);
};

//协会年产量折线图
export const getXHAccessChartYear = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/XHAccessChartYear`, {
    params: params,
  });
};

//协会年时间段量图
export const getXHAccessChartDay = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/XHAccessChartDay`, {
    params: params,
  });
};
//协会断线记录
export const XHOrgBrokenLineRecord = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetXHOrgBrokenLineRecord`, { params: params });
};
//协会操作日志
export const XHLog = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetXHLog`, { params: params });
};

//协会生产线监控
export const XHStationLineState = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetXHStationLineState`, { params: params });
};

// 协会工程方量汇总
export const XHGetProdManDataSummary = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/XHGetProdManDataSummary`, { params: params });
};
// 导出协协会工程方量汇总
export const XHDownProdManDataSummary = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/XHDownProdManDataSummary`, params, title);
};

//协会模块--结束